import Vue from 'vue';
import VueRouter from 'vue-router'
import _import from '@/utils/import'
import asyncRouterMap from './asyncRouterMap'
const Layout = _import('layout/Layout')

Vue.use(VueRouter)

export const constantRouterMap = [{
    path: '/401',
    component: _import('errorPage/401'),
    hidden: true
  },
  {
    path: '/404',
    component: _import('errorPage/404'),
    hidden: true
  },
  {
    path: '/login',
    component: _import('login/index'),
    hidden: true
  },
  {
    path: '/roadLogin',
    component: _import('login/mapLogin'),
    hidden: true
  },
  {
    path: '/lock',
    component: _import('lock/index'),
    name: 'lock',
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    meta: {
      title: '异常消费监控',
      icon: 'card'
    },
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: _import('dashboard/index'),
      meta: {
        title: 'dashboard',
        icon: 'cards',
        noCache: true
      }
    }]
  }
]

export const router = new VueRouter({
  routes: [
    ...constantRouterMap,
    ...asyncRouterMap
  ],
  scrollBehavior: () => ({
    y: 0
  })
})